import React from 'react';
import { Tooltip, Box } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

interface InfoIconProps {
  text: string;
  className?: string;
}

const InfoIconComponent = ({ text, className = '' }: InfoIconProps) => {
  return (
    <Tooltip title={text} arrow placement="top">
      <Box
        component="span"
        className={className}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 0.5,
          cursor: 'help',
          verticalAlign: 'middle',
        }}
      >
        <InfoIcon fontSize="small" sx={{ color: 'text.secondary' }} />
      </Box>
    </Tooltip>
  );
};

export default InfoIconComponent;
